// extracted by mini-css-extract-plugin
export default {"AuthLayout":"AuthLayout_AuthLayout__0xkQp","Brand":"AuthLayout_Brand__PqVOT","Footer":"AuthLayout_Footer__02lWv"};